import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import { Typography, Switch, withStyles } from '@material-ui/core';
const colorPrimary = '#9edbf7';
const StyledSwitch = withStyles(theme => ({
  switchBase: {
    color: colorPrimary,
    '&$checked': {
      color: colorPrimary
    },
    '&$checked + $track': {
      backgroundColor: colorPrimary
    }
  },
  checked: {},
  track: {}
}))(Switch);
const SwitchDiv = styled.div.withConfig({
  displayName: "ToggleSwitch__SwitchDiv",
  componentId: "sc-1bq47n6-0"
})(["margin-left:10px;margin-right:10px;display:flex;align-items:center;"]);
/**
 * @component
 * Basic, un-nested styled list. Pass messageKeys array to limit which  messages are
 * rendered.
 */

export const ToggleSwitch = (_ref) => {
  let {
    rightText,
    leftText,
    onToggle,
    isChecked
  } = _ref,
      props = _objectWithoutProperties(_ref, ["rightText", "leftText", "onToggle", "isChecked"]);

  return /*#__PURE__*/React.createElement(SwitchDiv, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, rightText), /*#__PURE__*/React.createElement(StyledSwitch, {
    checked: isChecked,
    size: "small",
    onChange: event => onToggle(event.target.checked),
    name: "measure",
    color: "primary"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, leftText));
};
export default ToggleSwitch;